import { createSlice } from '@reduxjs/toolkit'
import { createAsyncActions } from '@/utils/sagas'

const initialState = {
  isFetching: false,
  error: null,
  items: [],
}

export const fetchResources = createAsyncActions('apps/resources')

/*
  List of applications resources like in-app-upgrades, etc
*/
const resourcesSlice = createSlice({
  name: 'resources',
  initialState,
  extraReducers: ({ addCase }) => {
    addCase(fetchResources.pending, (state) => {
      state.isFetching = true
      state.error = null
    })

    addCase(fetchResources.fulfilled, (state, { payload }) => {
      state.isFetching = false
      state.items = payload.items
    })

    addCase(fetchResources.rejected, (state, { payload }) => {
      state.isFetching = false
      state.error = payload?.error
    })
  },
})

export const reducer = resourcesSlice.reducer
